import { useEffect } from "react";

export default function MissionSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="py-28 md:py-40 relative overflow-hidden"
      style={{ background: "#111111" }}
    >
      {/* Gold border frame */}
      <div className="absolute inset-12 border border-gold/15 rounded-3xl pointer-events-none" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <div className="reveal">
          <span className="inline-block text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase mb-10">
            Our Mission
          </span>

          <div className="mb-4">
            <i className="ri-double-quotes-l text-gold/20 text-8xl" />
          </div>

          <h2
            className="font-display font-bold text-white leading-snug -mt-8"
            style={{ fontSize: "clamp(1.6rem, 3.5vw, 2.8rem)" }}
          >
            To elevate creators through{" "}
            <span className="text-gradient-gold">hands-on training</span>,
            professional guidance, and a{" "}
            <span className="text-gradient-gold">supportive community</span>{" "}
            that pushes everyone to win.
          </h2>

          <i className="ri-double-quotes-r text-gold/20 text-8xl block mt-4" />
        </div>
      </div>
    </section>
  );
}
